import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/logos/sidebarlogo.png'


const _hoisted_1 = { class: "font-sans bg-gray-50 text-gray-800" }
const _hoisted_2 = {
  id: "header",
  class: "bg-white border-b border-gray-200 fixed w-full z-10"
}
const _hoisted_3 = { class: "flex items-center px-4 py-3" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = {
  id: "content-wrapper",
  class: "flex pt-14"
}
const _hoisted_6 = {
  id: "sidebar",
  class: "fixed top-14 left-0 w-64 h-screen bg-white overflow-y-auto border-r border-gray-200"
}
const _hoisted_7 = { class: "px-4 py-4" }
const _hoisted_8 = { class: "space-y-1" }
const _hoisted_9 = { class: "py-1" }
const _hoisted_10 = {
  key: 0,
  class: "mt-1 ml-6 space-y-1 border-l border-gray-200 pl-3"
}
const _hoisted_11 = { class: "py-1" }
const _hoisted_12 = {
  key: 0,
  class: "mt-1 ml-6 space-y-1 border-l border-gray-200 pl-3"
}
const _hoisted_13 = { class: "py-1" }
const _hoisted_14 = {
  key: 0,
  class: "mt-1 ml-6 space-y-1 border-l border-gray-200 pl-3"
}
const _hoisted_15 = { class: "py-1" }
const _hoisted_16 = {
  key: 0,
  class: "mt-1 ml-6 space-y-1 border-l border-gray-200 pl-3"
}
const _hoisted_17 = { class: "py-1" }
const _hoisted_18 = {
  key: 0,
  class: "mt-1 ml-6 space-y-1 border-l border-gray-200 pl-3"
}
const _hoisted_19 = { class: "py-1" }
const _hoisted_20 = {
  key: 0,
  class: "mt-1 ml-6 space-y-1 border-l border-gray-200 pl-3"
}
const _hoisted_21 = { class: "py-1" }
const _hoisted_22 = {
  key: 0,
  class: "mt-1 ml-6 space-y-1 border-l border-gray-200 pl-3"
}
const _hoisted_23 = { class: "py-1" }
const _hoisted_24 = {
  key: 0,
  class: "mt-1 ml-6 space-y-1 border-l border-gray-200 pl-3"
}
const _hoisted_25 = { class: "py-1" }
const _hoisted_26 = {
  key: 0,
  class: "mt-1 ml-6 space-y-1 border-l border-gray-200 pl-3"
}
const _hoisted_27 = {
  id: "main-content",
  class: "ml-64 flex-1 px-8 py-6 w-full"
}
const _hoisted_28 = { class: "w-full" }
const _hoisted_29 = { class: "mb-8" }
const _hoisted_30 = { class: "flex flex-wrap gap-4 mb-6" }
const _hoisted_31 = {
  id: "code-examples",
  class: "mb-10"
}
const _hoisted_32 = { class: "bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden mb-6" }
const _hoisted_33 = { class: "flex items-center justify-between p-4 border-b border-gray-200" }
const _hoisted_34 = { class: "relative" }
const _hoisted_35 = { class: "bg-black text-white p-4 font-mono text-sm overflow-x-auto" }
const _hoisted_36 = {
  key: 0,
  class: "language-javascript"
}
const _hoisted_37 = {
  key: 1,
  class: "language-python"
}
const _hoisted_38 = {
  key: 2,
  class: "language-bash"
}
const _hoisted_39 = {
  key: 3,
  class: "language-php"
}
const _hoisted_40 = {
  key: 4,
  class: "language-ruby"
}
const _hoisted_41 = { class: "p-4 bg-gray-50 border-t border-gray-200 flex justify-end" }
const _hoisted_42 = {
  id: "get-started",
  class: "mb-10"
}
const _hoisted_43 = { class: "bg-custom-blue border border-primary-200 rounded-lg p-6" }
const _hoisted_44 = { class: "flex flex-wrap gap-3" }

import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DocumentationPage',
  setup(__props) {

const openSections = ref(['Leads'])
const selectedLanguage = ref('javascript')
const copied = ref(false)

// Toggle section open/close - only one section can be open at a time
const toggleSection = (sectionName: string) => {
  const index = openSections.value.indexOf(sectionName)
  if (index > -1) {
    // אם התפריט כבר פתוח, סוגרים אותו
    openSections.value = []
  } else {
    // אם התפריט סגור, סוגרים את כל האחרים ופותחים רק אותו
    openSections.value = [sectionName]
  }
}

const getCodeExample = (language: string) => {
  const codeExamples: { [key: string]: string } = {
    javascript: `const apiKey = 'your_api_key_here';
const url = 'http://localhost:5000/leads/new-lead';

const headers = {
    'Authorization': \`Bearer \${apiKey}\`,
    'Content-Type': 'application/json'
};

// Example: Create a new lead
const leadData = {
    name: 'John Doe',
    phone: '050-1234567',
    status: 'new',
    source: 'website',
    hasCustomFields: false,
    email: 'yossi@example.com',
    company: 'חברת יוסי בע"מ'
};

fetch(url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(leadData)
})
.then(response => response.json())
.then(data => {
    if (data.success) {
        console.log('Lead created successfully:', data.lead_id);
    } else {
        console.error('Error:', data.error);
    }
})
.catch(error => console.error('Request failed:', error));`,
    
    python: `import requests
import json

api_key = "your_api_key_here"
url = "http://localhost:5000/leads/new-lead"

headers = {
    "Authorization": f"Bearer {api_key}",
    "Content-Type": "application/json"
}

# Example: Create a new lead
lead_data = {
    "name": "John Doe",
    "phone": "050-1234567",
    "status": "new",
    "source": "website",
    "hasCustomFields": False,
    "email": "yossi@example.com",
    "company": "חברת יוסי בע\\"מ"
}

response = requests.post(url, headers=headers, json=lead_data)

if response.status_code == 201:
    data = response.json()
    print("Lead created successfully:", data['lead_id'])
else:
    print(f"Error {response.status_code}: {response.json()}")`,
    
    curl: `# Create a new lead
curl -X POST "http://localhost:5000/leads/new-lead" \\
  -H "Authorization: Bearer your_api_key_here" \\
  -H "Content-Type: application/json" \\
  -d '{
    "name": "John Doe",
    "phone": "050-1234567",
    "status": "new",
    "source": "website",
    "hasCustomFields": false,
    "email": "yossi@example.com",
    "company": "חברת יוסי בע\\"מ"
  }'`,
    
    php: `<?php
$api_key = 'your_api_key_here';
$url = 'http://localhost:5000/leads/new-lead';

$headers = [
    'Authorization: Bearer ' . $api_key,
    'Content-Type: application/json'
];

// Example: Create a new lead
$lead_data = [
    'name' => 'John Doe',
    'phone' => '050-1234567',
    'status' => 'new',
    'source' => 'website',
    'hasCustomFields' => false,
    'email' => 'yossi@example.com',
    'company' => 'חברת יוסי בע"מ'
];

$ch = curl_init();
curl_setopt($ch, CURLOPT_URL, $url);
curl_setopt($ch, CURLOPT_POST, true);
curl_setopt($ch, CURLOPT_HTTPHEADER, $headers);
curl_setopt($ch, CURLOPT_POSTFIELDS, json_encode($lead_data));
curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);

$response = curl_exec($ch);
$http_code = curl_getinfo($ch, CURLINFO_HTTP_CODE);
curl_close($ch);

if ($http_code == 201) {
    $data = json_decode($response, true);
    echo "Lead created successfully: " . $data['lead_id'];
} else {
    echo "Error $http_code: $response";
}
?>`,
    
    ruby: `require 'net/http'
require 'json'

api_key = 'your_api_key_here'
url = URI('http://localhost:5000/leads/new-lead')

http = Net::HTTP.new(url.host, url.port)
request = Net::HTTP::Post.new(url)
request['Authorization'] = "Bearer #{api_key}"
request['Content-Type'] = 'application/json'

# Example: Create a new lead
lead_data = {
  name: 'John Doe',
  phone: '050-1234567',
  status: 'new',
  source: 'website',
  hasCustomFields: false,
  email: 'yossi@example.com',
  company: 'חברת יוסי בע"מ'
}

request.body = lead_data.to_json
response = http.request(request)

if response.code == '201'
  data = JSON.parse(response.body)
  puts "Lead created successfully: #{data['lead_id']}"
else
  puts "Error #{response.code}: #{response.body}"
end`
  }
  
  return codeExamples[language] || codeExamples.javascript
}

const copyCodeToClipboard = async () => {
  try {
    const codeText = getCodeExample(selectedLanguage.value)
    
    // Use the Clipboard API if available
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(codeText)
    } else {
      // Fallback for older browsers or non-secure contexts
      const textArea = document.createElement('textarea')
      textArea.value = codeText
      textArea.style.position = 'fixed'
      textArea.style.left = '-999999px'
      textArea.style.top = '-999999px'
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      document.execCommand('copy')
      textArea.remove()
    }
    
    // Show success feedback
    copied.value = true
    setTimeout(() => {
      copied.value = false
    }, 2000) // Reset after 2 seconds
    
  } catch (err) {
    console.error('Failed to copy code: ', err)
    // Could add error notification here
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "text-xl font-bold flex items-center text-custom-button-blue hover:text-custom-dark-blue"
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "ClickAI",
                class: "h-10"
              }, null, -1)
            ])),
            _: 1,
            __: [10]
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("ul", _hoisted_8, [
            _cache[71] || (_cache[71] = _createElementVNode("li", null, [
              _createElementVNode("span", { class: "block py-2 px-3 bg-primary-50 text-primary-700 rounded-md font-medium cursor-pointer" }, [
                _createElementVNode("i", { class: "fa-solid fa-book-open mr-2" }),
                _createTextVNode(" Introduction ")
              ])
            ], -1)),
            _createElementVNode("li", _hoisted_9, [
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSection('Leads'))),
                class: "flex items-center justify-between text-gray-700 hover:text-gray-900 py-2 px-3 rounded-md cursor-pointer hover:bg-gray-50",
                title: "Manage potential customers and track their interactions"
              }, [
                _cache[11] || (_cache[11] = _createElementVNode("span", null, [
                  _createElementVNode("i", { class: "fa-solid fa-user-plus mr-2" }),
                  _createTextVNode(" Leads")
                ], -1)),
                _createElementVNode("i", {
                  class: _normalizeClass(["fa-solid text-xs text-gray-400 transition-transform duration-200", openSections.value.includes('Leads') ? 'fa-chevron-up' : 'fa-chevron-down'])
                }, null, 2)
              ]),
              (openSections.value.includes('Leads'))
                ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/api-overview/leads",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer font-semibold"
                      }, {
                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createElementVNode("i", { class: "fa-solid fa-eye mr-2 text-primary-600" }, null, -1),
                          _createTextVNode(" Overview ")
                        ])),
                        _: 1,
                        __: [12]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/leads-custom-fields",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                          _createElementVNode("span", { class: "text-xs bg-green-100 text-green-800 px-1 rounded mr-2" }, "GET", -1),
                          _createTextVNode(" Get custom fields ")
                        ])),
                        _: 1,
                        __: [13]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/leads-new-lead",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Create new lead ")
                        ])),
                        _: 1,
                        __: [14]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/leads-edit-lead",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[15] || (_cache[15] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Edit lead ")
                        ])),
                        _: 1,
                        __: [15]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/leads-get-lead",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[16] || (_cache[16] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Get lead by ID ")
                        ])),
                        _: 1,
                        __: [16]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/leads-get-lead-phone",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[17] || (_cache[17] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Get leads by phone ")
                        ])),
                        _: 1,
                        __: [17]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/leads-add-call-log",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[18] || (_cache[18] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Add call log ")
                        ])),
                        _: 1,
                        __: [18]
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("li", _hoisted_11, [
              _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleSection('Deals'))),
                class: "flex items-center justify-between text-gray-700 hover:text-gray-900 py-2 px-3 rounded-md cursor-pointer hover:bg-gray-50",
                title: "Track sales opportunities and manage deal pipeline"
              }, [
                _cache[19] || (_cache[19] = _createElementVNode("span", null, [
                  _createElementVNode("i", { class: "fa-solid fa-handshake mr-2" }),
                  _createTextVNode(" Deals")
                ], -1)),
                _createElementVNode("i", {
                  class: _normalizeClass(["fa-solid text-xs text-gray-400 transition-transform duration-200", openSections.value.includes('Deals') ? 'fa-chevron-up' : 'fa-chevron-down'])
                }, null, 2)
              ]),
              (openSections.value.includes('Deals'))
                ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/api-overview/deals",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer font-semibold"
                      }, {
                        default: _withCtx(() => _cache[20] || (_cache[20] = [
                          _createElementVNode("i", { class: "fa-solid fa-eye mr-2 text-primary-600" }, null, -1),
                          _createTextVNode(" Overview ")
                        ])),
                        _: 1,
                        __: [20]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/deals-custom-fields",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[21] || (_cache[21] = [
                          _createElementVNode("span", { class: "text-xs bg-green-100 text-green-800 px-1 rounded mr-2" }, "GET", -1),
                          _createTextVNode(" Get custom fields ")
                        ])),
                        _: 1,
                        __: [21]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/deals-new-deal",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[22] || (_cache[22] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Create new deal ")
                        ])),
                        _: 1,
                        __: [22]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/deals-edit-deal",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[23] || (_cache[23] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Edit deal ")
                        ])),
                        _: 1,
                        __: [23]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/deals-get-deal",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[24] || (_cache[24] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Get deal by ID ")
                        ])),
                        _: 1,
                        __: [24]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/deals-get-deal-phone",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[25] || (_cache[25] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Get deals by phone ")
                        ])),
                        _: 1,
                        __: [25]
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("li", _hoisted_13, [
              _createElementVNode("div", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleSection('Customers'))),
                class: "flex items-center justify-between text-gray-700 hover:text-gray-900 py-2 px-3 rounded-md cursor-pointer hover:bg-gray-50",
                title: "Manage customer profiles and relationships"
              }, [
                _cache[26] || (_cache[26] = _createElementVNode("span", null, [
                  _createElementVNode("i", { class: "fa-solid fa-users mr-2" }),
                  _createTextVNode(" Customers")
                ], -1)),
                _createElementVNode("i", {
                  class: _normalizeClass(["fa-solid text-xs text-gray-400 transition-transform duration-200", openSections.value.includes('Customers') ? 'fa-chevron-up' : 'fa-chevron-down'])
                }, null, 2)
              ]),
              (openSections.value.includes('Customers'))
                ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/api-overview/customers",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer font-semibold"
                      }, {
                        default: _withCtx(() => _cache[27] || (_cache[27] = [
                          _createElementVNode("i", { class: "fa-solid fa-eye mr-2 text-primary-600" }, null, -1),
                          _createTextVNode(" Overview ")
                        ])),
                        _: 1,
                        __: [27]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/customers-custom-fields",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[28] || (_cache[28] = [
                          _createElementVNode("span", { class: "text-xs bg-green-100 text-green-800 px-1 rounded mr-2" }, "GET", -1),
                          _createTextVNode(" Get custom fields ")
                        ])),
                        _: 1,
                        __: [28]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/customers-create-customer",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[29] || (_cache[29] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Create customer ")
                        ])),
                        _: 1,
                        __: [29]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/customers-get-customer",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[30] || (_cache[30] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Get customer by ID ")
                        ])),
                        _: 1,
                        __: [30]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/customers-get-customer-phone",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[31] || (_cache[31] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Get customers by phone ")
                        ])),
                        _: 1,
                        __: [31]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/customers-edit-customer",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[32] || (_cache[32] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Edit customer ")
                        ])),
                        _: 1,
                        __: [32]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/customers-add-call-log",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[33] || (_cache[33] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Add call log ")
                        ])),
                        _: 1,
                        __: [33]
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("li", _hoisted_15, [
              _createElementVNode("div", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleSection('Products'))),
                class: "flex items-center justify-between text-gray-700 hover:text-gray-900 py-2 px-3 rounded-md cursor-pointer hover:bg-gray-50",
                title: "Manage product catalog and variations"
              }, [
                _cache[34] || (_cache[34] = _createElementVNode("span", null, [
                  _createElementVNode("i", { class: "fa-solid fa-box mr-2" }),
                  _createTextVNode(" Products")
                ], -1)),
                _createElementVNode("i", {
                  class: _normalizeClass(["fa-solid text-xs text-gray-400 transition-transform duration-200", openSections.value.includes('Products') ? 'fa-chevron-up' : 'fa-chevron-down'])
                }, null, 2)
              ]),
              (openSections.value.includes('Products'))
                ? (_openBlock(), _createElementBlock("ul", _hoisted_16, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/api-overview/products",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer font-semibold"
                      }, {
                        default: _withCtx(() => _cache[35] || (_cache[35] = [
                          _createElementVNode("i", { class: "fa-solid fa-eye mr-2 text-primary-600" }, null, -1),
                          _createTextVNode(" Overview ")
                        ])),
                        _: 1,
                        __: [35]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/products-get-all",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[36] || (_cache[36] = [
                          _createElementVNode("span", { class: "text-xs bg-green-100 text-green-800 px-1 rounded mr-2" }, "GET", -1),
                          _createTextVNode(" Get all products ")
                        ])),
                        _: 1,
                        __: [36]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/products-get-product",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[37] || (_cache[37] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Get product by ID ")
                        ])),
                        _: 1,
                        __: [37]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/products-create-product",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[38] || (_cache[38] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Create product ")
                        ])),
                        _: 1,
                        __: [38]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/products-edit-product",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[39] || (_cache[39] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Edit product ")
                        ])),
                        _: 1,
                        __: [39]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/products-add-variations",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[40] || (_cache[40] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Add variations ")
                        ])),
                        _: 1,
                        __: [40]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/products-delete-variation",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[41] || (_cache[41] = [
                          _createElementVNode("span", { class: "text-xs bg-red-100 text-red-800 px-1 rounded mr-2" }, "DEL", -1),
                          _createTextVNode(" Delete variation ")
                        ])),
                        _: 1,
                        __: [41]
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("li", _hoisted_17, [
              _createElementVNode("div", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleSection('Calendar'))),
                class: "flex items-center justify-between text-gray-700 hover:text-gray-900 py-2 px-3 rounded-md cursor-pointer hover:bg-gray-50",
                title: "Schedule meetings and manage appointments"
              }, [
                _cache[42] || (_cache[42] = _createElementVNode("span", null, [
                  _createElementVNode("i", { class: "fa-solid fa-calendar mr-2" }),
                  _createTextVNode(" Calendar")
                ], -1)),
                _createElementVNode("i", {
                  class: _normalizeClass(["fa-solid text-xs text-gray-400 transition-transform duration-200", openSections.value.includes('Calendar') ? 'fa-chevron-up' : 'fa-chevron-down'])
                }, null, 2)
              ]),
              (openSections.value.includes('Calendar'))
                ? (_openBlock(), _createElementBlock("ul", _hoisted_18, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/api-overview/calendar",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer font-semibold"
                      }, {
                        default: _withCtx(() => _cache[43] || (_cache[43] = [
                          _createElementVNode("i", { class: "fa-solid fa-eye mr-2 text-primary-600" }, null, -1),
                          _createTextVNode(" Overview ")
                        ])),
                        _: 1,
                        __: [43]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/calendar-get-appointment-types",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[44] || (_cache[44] = [
                          _createElementVNode("span", { class: "text-xs bg-green-100 text-green-800 px-1 rounded mr-2" }, "GET", -1),
                          _createTextVNode(" Get appointment types ")
                        ])),
                        _: 1,
                        __: [44]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/calendar-get-appointment-users",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[45] || (_cache[45] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Get appointment users ")
                        ])),
                        _: 1,
                        __: [45]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/calendar-appointment-type-details",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[46] || (_cache[46] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Get appointment details ")
                        ])),
                        _: 1,
                        __: [46]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/calendar-get-user-working-hours",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[47] || (_cache[47] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Get user working hours ")
                        ])),
                        _: 1,
                        __: [47]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/calendar-get-break-hours",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[48] || (_cache[48] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Get break hours ")
                        ])),
                        _: 1,
                        __: [48]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/calendar-get-free-time-slot",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[49] || (_cache[49] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Get free time slots ")
                        ])),
                        _: 1,
                        __: [49]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/calendar-get-double-free-time-slot",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[50] || (_cache[50] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Get double free slots ")
                        ])),
                        _: 1,
                        __: [50]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/calendar-get-user-appointment-by-date",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[51] || (_cache[51] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Get user appointments ")
                        ])),
                        _: 1,
                        __: [51]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/calendar-schedule-meeting",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[52] || (_cache[52] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Schedule meeting ")
                        ])),
                        _: 1,
                        __: [52]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/calendar-create-event-type",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[53] || (_cache[53] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Create event type ")
                        ])),
                        _: 1,
                        __: [53]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/calendar-edit-event-type",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[54] || (_cache[54] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Edit event type ")
                        ])),
                        _: 1,
                        __: [54]
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("li", _hoisted_19, [
              _createElementVNode("div", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleSection('Team'))),
                class: "flex items-center justify-between text-gray-700 hover:text-gray-900 py-2 px-3 rounded-md cursor-pointer hover:bg-gray-50",
                title: "Manage team members and user accounts"
              }, [
                _cache[55] || (_cache[55] = _createElementVNode("span", null, [
                  _createElementVNode("i", { class: "fa-solid fa-users-gear mr-2" }),
                  _createTextVNode(" Team")
                ], -1)),
                _createElementVNode("i", {
                  class: _normalizeClass(["fa-solid text-xs text-gray-400 transition-transform duration-200", openSections.value.includes('Team') ? 'fa-chevron-up' : 'fa-chevron-down'])
                }, null, 2)
              ]),
              (openSections.value.includes('Team'))
                ? (_openBlock(), _createElementBlock("ul", _hoisted_20, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/api-overview/team",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer font-semibold"
                      }, {
                        default: _withCtx(() => _cache[56] || (_cache[56] = [
                          _createElementVNode("i", { class: "fa-solid fa-eye mr-2 text-primary-600" }, null, -1),
                          _createTextVNode(" Overview ")
                        ])),
                        _: 1,
                        __: [56]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/team-list",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[57] || (_cache[57] = [
                          _createElementVNode("span", { class: "text-xs bg-green-100 text-green-800 px-1 rounded mr-2" }, "GET", -1),
                          _createTextVNode(" Get team members ")
                        ])),
                        _: 1,
                        __: [57]
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("li", _hoisted_21, [
              _createElementVNode("div", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (toggleSection('Tasks'))),
                class: "flex items-center justify-between text-gray-700 hover:text-gray-900 py-2 px-3 rounded-md cursor-pointer hover:bg-gray-50",
                title: "Create and manage tasks and assignments"
              }, [
                _cache[58] || (_cache[58] = _createElementVNode("span", null, [
                  _createElementVNode("i", { class: "fa-solid fa-list-check mr-2" }),
                  _createTextVNode(" Tasks")
                ], -1)),
                _createElementVNode("i", {
                  class: _normalizeClass(["fa-solid text-xs text-gray-400 transition-transform duration-200", openSections.value.includes('Tasks') ? 'fa-chevron-up' : 'fa-chevron-down'])
                }, null, 2)
              ]),
              (openSections.value.includes('Tasks'))
                ? (_openBlock(), _createElementBlock("ul", _hoisted_22, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/api-overview/tasks",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer font-semibold"
                      }, {
                        default: _withCtx(() => _cache[59] || (_cache[59] = [
                          _createElementVNode("i", { class: "fa-solid fa-eye mr-2 text-primary-600" }, null, -1),
                          _createTextVNode(" Overview ")
                        ])),
                        _: 1,
                        __: [59]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/tasks-create-task",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[60] || (_cache[60] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Create task ")
                        ])),
                        _: 1,
                        __: [60]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/tasks-edit-task",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[61] || (_cache[61] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Edit task ")
                        ])),
                        _: 1,
                        __: [61]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/tasks-delete-task",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[62] || (_cache[62] = [
                          _createElementVNode("span", { class: "text-xs bg-red-100 text-red-800 px-1 rounded mr-2" }, "DEL", -1),
                          _createTextVNode(" Delete task ")
                        ])),
                        _: 1,
                        __: [62]
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("li", _hoisted_23, [
              _createElementVNode("div", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (toggleSection('Contacts'))),
                class: "flex items-center justify-between text-gray-700 hover:text-gray-900 py-2 px-3 rounded-md cursor-pointer hover:bg-gray-50",
                title: "Manage contact information and address book"
              }, [
                _cache[63] || (_cache[63] = _createElementVNode("span", null, [
                  _createElementVNode("i", { class: "fa-solid fa-address-book mr-2" }),
                  _createTextVNode(" Contacts")
                ], -1)),
                _createElementVNode("i", {
                  class: _normalizeClass(["fa-solid text-xs text-gray-400 transition-transform duration-200", openSections.value.includes('Contacts') ? 'fa-chevron-up' : 'fa-chevron-down'])
                }, null, 2)
              ]),
              (openSections.value.includes('Contacts'))
                ? (_openBlock(), _createElementBlock("ul", _hoisted_24, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/api-overview/contacts",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer font-semibold"
                      }, {
                        default: _withCtx(() => _cache[64] || (_cache[64] = [
                          _createElementVNode("i", { class: "fa-solid fa-eye mr-2 text-primary-600" }, null, -1),
                          _createTextVNode(" Overview ")
                        ])),
                        _: 1,
                        __: [64]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/contacts-create-contact",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[65] || (_cache[65] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Create new contact ")
                        ])),
                        _: 1,
                        __: [65]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/contacts-find-by-phone",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[66] || (_cache[66] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Find by phone ")
                        ])),
                        _: 1,
                        __: [66]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/contacts-find-by-name",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[67] || (_cache[67] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Find by name ")
                        ])),
                        _: 1,
                        __: [67]
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("li", _hoisted_25, [
              _createElementVNode("div", {
                onClick: _cache[8] || (_cache[8] = ($event: any) => (toggleSection('Chats'))),
                class: "flex items-center justify-between text-gray-700 hover:text-gray-900 py-2 px-3 rounded-md cursor-pointer hover:bg-gray-50",
                title: "Send messages and manage chat communications"
              }, [
                _cache[68] || (_cache[68] = _createElementVNode("span", null, [
                  _createElementVNode("i", { class: "fa-solid fa-comments mr-2" }),
                  _createTextVNode(" Chats")
                ], -1)),
                _createElementVNode("i", {
                  class: _normalizeClass(["fa-solid text-xs text-gray-400 transition-transform duration-200", openSections.value.includes('Chats') ? 'fa-chevron-up' : 'fa-chevron-down'])
                }, null, 2)
              ]),
              (openSections.value.includes('Chats'))
                ? (_openBlock(), _createElementBlock("ul", _hoisted_26, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/api-overview/chats",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer font-semibold"
                      }, {
                        default: _withCtx(() => _cache[69] || (_cache[69] = [
                          _createElementVNode("i", { class: "fa-solid fa-eye mr-2 text-primary-600" }, null, -1),
                          _createTextVNode(" Overview ")
                        ])),
                        _: 1,
                        __: [69]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: "/endpoint/chats-send-message",
                        class: "block py-1 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
                      }, {
                        default: _withCtx(() => _cache[70] || (_cache[70] = [
                          _createElementVNode("span", { class: "text-xs bg-blue-100 text-blue-800 px-1 rounded mr-2" }, "POST", -1),
                          _createTextVNode(" Send message ")
                        ])),
                        _: 1,
                        __: [70]
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _cache[74] || (_cache[74] = _createElementVNode("h1", { class: "text-3xl font-bold text-gray-800 mb-4" }, " Click AI API Overview ", -1)),
            _cache[75] || (_cache[75] = _createElementVNode("p", { class: "text-gray-600 text-lg mb-6" }, " Automate your business workflows and integrate Click AI's powerful features into your applications with our comprehensive API. ", -1)),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_router_link, {
                to: "/api-overview/leads",
                class: "inline-flex items-center px-4 py-2 bg-custom-button-blue text-white rounded-md font-medium hover:bg-custom-button-blue-dark transition cursor-pointer"
              }, {
                default: _withCtx(() => _cache[72] || (_cache[72] = [
                  _createElementVNode("i", { class: "fa-solid fa-play mr-2" }, null, -1),
                  _createTextVNode(" Quick Start ")
                ])),
                _: 1,
                __: [72]
              }),
              _createVNode(_component_router_link, {
                to: "/settings/api-settings",
                class: "inline-flex items-center px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-md font-medium hover:bg-gray-50 transition cursor-pointer"
              }, {
                default: _withCtx(() => _cache[73] || (_cache[73] = [
                  _createElementVNode("i", { class: "fa-solid fa-key mr-2" }, null, -1),
                  _createTextVNode(" Get API Keys ")
                ])),
                _: 1,
                __: [73]
              })
            ])
          ]),
          _cache[83] || (_cache[83] = _createStaticVNode("<div id=\"capabilities\" class=\"mb-10\" data-v-603e7a45><h2 class=\"text-2xl font-bold text-gray-800 mb-4\" data-v-603e7a45> API Capabilities </h2><div class=\"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6\" data-v-603e7a45><div class=\"bg-white p-5 rounded-lg border border-gray-200 shadow-sm\" data-v-603e7a45><div class=\"flex items-center mb-3\" data-v-603e7a45><div class=\"bg-custom-blue p-2 rounded-md text-custom-button-blue mr-3\" data-v-603e7a45><i class=\"fa-solid fa-user-plus\" data-v-603e7a45></i></div><h3 class=\"text-lg font-semibold\" data-v-603e7a45>Lead Management</h3></div><p class=\"text-gray-600\" data-v-603e7a45>Create and manage leads, track interactions, search by phone, and add call logs. 6 endpoints available.</p></div><div class=\"bg-white p-5 rounded-lg border border-gray-200 shadow-sm\" data-v-603e7a45><div class=\"flex items-center mb-3\" data-v-603e7a45><div class=\"bg-custom-blue p-2 rounded-md text-custom-button-blue mr-3\" data-v-603e7a45><i class=\"fa-solid fa-handshake\" data-v-603e7a45></i></div><h3 class=\"text-lg font-semibold\" data-v-603e7a45>Deal Management</h3></div><p class=\"text-gray-600\" data-v-603e7a45>Track deals through your pipeline, associate with customers and products. 5 endpoints available.</p></div><div class=\"bg-white p-5 rounded-lg border border-gray-200 shadow-sm\" data-v-603e7a45><div class=\"flex items-center mb-3\" data-v-603e7a45><div class=\"bg-custom-blue p-2 rounded-md text-custom-button-blue mr-3\" data-v-603e7a45><i class=\"fa-solid fa-users\" data-v-603e7a45></i></div><h3 class=\"text-lg font-semibold\" data-v-603e7a45>Customer Management</h3></div><p class=\"text-gray-600\" data-v-603e7a45>Maintain customer profiles, track interactions, and manage customer relationships. 6 endpoints available.</p></div><div class=\"bg-white p-5 rounded-lg border border-gray-200 shadow-sm\" data-v-603e7a45><div class=\"flex items-center mb-3\" data-v-603e7a45><div class=\"bg-custom-blue p-2 rounded-md text-custom-button-blue mr-3\" data-v-603e7a45><i class=\"fa-solid fa-box\" data-v-603e7a45></i></div><h3 class=\"text-lg font-semibold\" data-v-603e7a45>Product Management</h3></div><p class=\"text-gray-600\" data-v-603e7a45>Create products with variations, organize by categories, and manage inventory. 6 endpoints available.</p></div><div class=\"bg-white p-5 rounded-lg border border-gray-200 shadow-sm\" data-v-603e7a45><div class=\"flex items-center mb-3\" data-v-603e7a45><div class=\"bg-custom-blue p-2 rounded-md text-custom-button-blue mr-3\" data-v-603e7a45><i class=\"fa-solid fa-calendar\" data-v-603e7a45></i></div><h3 class=\"text-lg font-semibold\" data-v-603e7a45>Calendar &amp; Appointments</h3></div><p class=\"text-gray-600\" data-v-603e7a45>Schedule meetings, find time slots, manage appointment types and working hours. 11 endpoints available.</p></div><div class=\"bg-white p-5 rounded-lg border border-gray-200 shadow-sm\" data-v-603e7a45><div class=\"flex items-center mb-3\" data-v-603e7a45><div class=\"bg-custom-blue p-2 rounded-md text-custom-button-blue mr-3\" data-v-603e7a45><i class=\"fa-solid fa-list-check\" data-v-603e7a45></i></div><h3 class=\"text-lg font-semibold\" data-v-603e7a45>Tasks &amp; Contacts</h3></div><p class=\"text-gray-600\" data-v-603e7a45>Create and assign tasks, track progress, manage contacts, and send messages. 7 endpoints available.</p></div></div></div>", 1)),
          _createElementVNode("div", _hoisted_31, [
            _cache[78] || (_cache[78] = _createElementVNode("h2", { class: "text-2xl font-bold text-gray-800 mb-4" }, " Code Examples ", -1)),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _cache[77] || (_cache[77] = _createElementVNode("h3", { class: "font-semibold text-custom-dark-gray" }, "Create New Lead Example", -1)),
                _createElementVNode("div", _hoisted_34, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((selectedLanguage).value = $event)),
                    class: "pl-3 pr-3 py-1 border border-gray-300 rounded-md bg-white text-sm focus:outline-none focus:ring-1 focus:ring-primary-500"
                  }, _cache[76] || (_cache[76] = [
                    _createStaticVNode("<option value=\"javascript\" data-v-603e7a45>JavaScript</option><option value=\"python\" data-v-603e7a45>Python</option><option value=\"curl\" data-v-603e7a45>cURL</option><option value=\"php\" data-v-603e7a45>PHP</option><option value=\"ruby\" data-v-603e7a45>Ruby</option>", 5)
                  ]), 512), [
                    [_vModelSelect, selectedLanguage.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                (selectedLanguage.value === 'javascript')
                  ? (_openBlock(), _createElementBlock("pre", _hoisted_36, "const apiKey = 'your_api_key_here';\nconst url = 'http://localhost:5000/leads/new-lead';\n\nconst headers = {\n    'Authorization': `Bearer ${apiKey}`,\n    'Content-Type': 'application/json'\n};\n\n// Example: Create a new lead\nconst leadData = {\n    name: 'John Doe',\n    phone: '050-1234567',\n    status: 'new',\n    source: 'website',\n    hasCustomFields: false,\n    email: 'yossi@example.com',\n    company: 'חברת יוסי בע\"מ'\n};\n\nfetch(url, {\n    method: 'POST',\n    headers: headers,\n    body: JSON.stringify(leadData)\n})\n.then(response => response.json())\n.then(data => {\n    if (data.success) {\n        console.log('Lead created successfully:', data.lead_id);\n    } else {\n        console.error('Error:', data.error);\n    }\n})\n.catch(error => console.error('Request failed:', error));"))
                  : _createCommentVNode("", true),
                (selectedLanguage.value === 'python')
                  ? (_openBlock(), _createElementBlock("pre", _hoisted_37, "import requests\nimport json\n\napi_key = \"your_api_key_here\"\nurl = \"http://localhost:5000/leads/new-lead\"\n\nheaders = {\n    \"Authorization\": f\"Bearer {api_key}\",\n    \"Content-Type\": \"application/json\"\n}\n\n# Example: Create a new lead\nlead_data = {\n    \"name\": \"John Doe\",\n    \"phone\": \"050-1234567\",\n    \"status\": \"new\",\n    \"source\": \"website\",\n    \"hasCustomFields\": False,\n    \"email\": \"yossi@example.com\",\n    \"company\": \"חברת יוסי בע\\\"מ\"\n}\n\nresponse = requests.post(url, headers=headers, json=lead_data)\n\nif response.status_code == 201:\n    data = response.json()\n    print(\"Lead created successfully:\", data['lead_id'])\nelse:\n    print(f\"Error {response.status_code}: {response.json()}\")"))
                  : _createCommentVNode("", true),
                (selectedLanguage.value === 'curl')
                  ? (_openBlock(), _createElementBlock("pre", _hoisted_38, "# Create a new lead\ncurl -X POST \"http://localhost:5000/leads/new-lead\" \\\n  -H \"Authorization: Bearer your_api_key_here\" \\\n  -H \"Content-Type: application/json\" \\\n  -d '{\n    \"name\": \"John Doe\",\n    \"phone\": \"050-1234567\",\n    \"status\": \"new\",\n    \"source\": \"website\",\n    \"hasCustomFields\": false,\n    \"email\": \"yossi@example.com\",\n    \"company\": \"חברת יוסי בע\\\"מ\"\n  }'"))
                  : _createCommentVNode("", true),
                (selectedLanguage.value === 'php')
                  ? (_openBlock(), _createElementBlock("pre", _hoisted_39, "<?php\n$api_key = 'your_api_key_here';\n$url = 'http://localhost:5000/leads/new-lead';\n\n$headers = [\n    'Authorization: Bearer ' . $api_key,\n    'Content-Type: application/json'\n];\n\n// Example: Create a new lead\n$lead_data = [\n    'name' => 'John Doe',\n    'phone' => '050-1234567',\n    'status' => 'new',\n    'source' => 'website',\n    'hasCustomFields' => false,\n    'email' => 'yossi@example.com',\n    'company' => 'חברת יוסי בע\"מ'\n];\n\n$ch = curl_init();\ncurl_setopt($ch, CURLOPT_URL, $url);\ncurl_setopt($ch, CURLOPT_POST, true);\ncurl_setopt($ch, CURLOPT_HTTPHEADER, $headers);\ncurl_setopt($ch, CURLOPT_POSTFIELDS, json_encode($lead_data));\ncurl_setopt($ch, CURLOPT_RETURNTRANSFER, true);\n\n$response = curl_exec($ch);\n$http_code = curl_getinfo($ch, CURLINFO_HTTP_CODE);\ncurl_close($ch);\n\nif ($http_code == 201) {\n    $data = json_decode($response, true);\n    echo \"Lead created successfully: \" . $data['lead_id'];\n} else {\n    echo \"Error $http_code: $response\";\n}\n?>"))
                  : _createCommentVNode("", true),
                (selectedLanguage.value === 'ruby')
                  ? (_openBlock(), _createElementBlock("pre", _hoisted_40, "require 'net/http'\nrequire 'json'\n\napi_key = 'your_api_key_here'\nurl = URI('http://localhost:5000/leads/new-lead')\n\nhttp = Net::HTTP.new(url.host, url.port)\nrequest = Net::HTTP::Post.new(url)\nrequest['Authorization'] = \"Bearer #{api_key}\"\nrequest['Content-Type'] = 'application/json'\n\n# Example: Create a new lead\nlead_data = {\n  name: 'John Doe',\n  phone: '050-1234567',\n  status: 'new',\n  source: 'website',\n  hasCustomFields: false,\n  email: 'yossi@example.com',\n  company: 'חברת יוסי בע\"מ'\n}\n\nrequest.body = lead_data.to_json\nresponse = http.request(request)\n\nif response.code == '201'\n  data = JSON.parse(response.body)\n  puts \"Lead created successfully: #{data['lead_id']}\"\nelse\n  puts \"Error #{response.code}: #{response.body}\"\nend"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("button", {
                  onClick: copyCodeToClipboard,
                  class: _normalizeClass(["px-3 py-1 bg-custom-button-blue text-white rounded text-sm font-medium hover:bg-custom-button-blue-dark transition", { 'bg-green-600 hover:bg-green-700': copied.value }])
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass([copied.value ? 'fa-solid fa-check' : 'fa-solid fa-copy', "mr-1"])
                  }, null, 2),
                  _createTextVNode(" " + _toDisplayString(copied.value ? 'Copied!' : 'Copy Code'), 1)
                ], 2)
              ])
            ])
          ]),
          _cache[84] || (_cache[84] = _createStaticVNode("<div id=\"authentication\" class=\"mb-10\" data-v-603e7a45><h2 class=\"text-2xl font-bold text-gray-800 mb-4\" data-v-603e7a45> Authentication </h2><div class=\"bg-white p-5 rounded-lg border border-gray-200 shadow-sm mb-6\" data-v-603e7a45><p class=\"mb-4 text-gray-700\" data-v-603e7a45> All API requests require authentication using API keys. You can generate API keys from your Click AI dashboard. </p><div class=\"bg-yellow-100 border-l-4 border-yellow-400 p-4 mb-4\" data-v-603e7a45><div class=\"flex\" data-v-603e7a45><div class=\"flex-shrink-0\" data-v-603e7a45><i class=\"fa-solid fa-triangle-exclamation text-yellow-400\" data-v-603e7a45></i></div><div class=\"ml-3\" data-v-603e7a45><p class=\"text-sm text-yellow-700\" data-v-603e7a45> Keep your API keys secure and never expose them. </p></div></div></div><h3 class=\"text-lg font-semibold mb-2\" data-v-603e7a45>API Key Authentication</h3><div class=\"bg-gray-100 p-4 rounded-md font-mono text-sm mb-4\" data-v-603e7a45><code data-v-603e7a45>Authorization: Bearer YOUR_API_KEY</code></div></div></div><div id=\"rate-limits\" class=\"mb-10\" data-v-603e7a45><h2 class=\"text-2xl font-bold text-gray-800 mb-4\" data-v-603e7a45> Rate Limits </h2><div class=\"overflow-hidden bg-white shadow-sm border border-gray-200 rounded-lg\" data-v-603e7a45><table class=\"min-w-full divide-y divide-gray-200\" data-v-603e7a45><thead class=\"bg-gray-50\" data-v-603e7a45><tr data-v-603e7a45><th scope=\"col\" class=\"px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider\" data-v-603e7a45> Plan </th><th scope=\"col\" class=\"px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider\" data-v-603e7a45> Requests per minute </th><th scope=\"col\" class=\"px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider\" data-v-603e7a45> Daily limit </th></tr></thead><tbody class=\"bg-white divide-y divide-gray-200\" data-v-603e7a45><tr data-v-603e7a45><td class=\"px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900\" data-v-603e7a45> Free </td><td class=\"px-6 py-4 whitespace-nowrap text-sm text-gray-500\" data-v-603e7a45> 10 </td><td class=\"px-6 py-4 whitespace-nowrap text-sm text-gray-500\" data-v-603e7a45> 50 </td></tr><tr data-v-603e7a45><td class=\"px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900\" data-v-603e7a45> Pro </td><td class=\"px-6 py-4 whitespace-nowrap text-sm text-gray-500\" data-v-603e7a45> 60 </td><td class=\"px-6 py-4 whitespace-nowrap text-sm text-gray-500\" data-v-603e7a45> 20,000 </td></tr><tr data-v-603e7a45><td class=\"px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900\" data-v-603e7a45> Enterprise </td><td class=\"px-6 py-4 whitespace-nowrap text-sm text-gray-500\" data-v-603e7a45> 300 </td><td class=\"px-6 py-4 whitespace-nowrap text-sm text-gray-500\" data-v-603e7a45> Unlimited </td></tr></tbody></table></div></div>", 2)),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _cache[81] || (_cache[81] = _createElementVNode("h2", { class: "text-2xl font-bold text-custom-dark-blue mb-3" }, " Ready to get started? ", -1)),
              _cache[82] || (_cache[82] = _createElementVNode("p", { class: "text-custom-medium-blue mb-4" }, " Explore our API endpoints and integrate Click AI's powerful features into your applications. ", -1)),
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_router_link, {
                  to: "/endpoint/leads-custom-fields",
                  class: "inline-flex items-center px-4 py-2 bg-custom-button-blue text-white rounded-md font-medium hover:bg-custom-button-blue-dark transition cursor-pointer"
                }, {
                  default: _withCtx(() => _cache[79] || (_cache[79] = [
                    _createElementVNode("i", { class: "fa-solid fa-code mr-2" }, null, -1),
                    _createTextVNode(" Explore Endpoints ")
                  ])),
                  _: 1,
                  __: [79]
                }),
                _createVNode(_component_router_link, {
                  to: "/api-overview/leads",
                  class: "inline-flex items-center px-4 py-2 bg-white border border-primary-300 text-custom-medium-blue rounded-md font-medium hover:bg-primary-50 transition cursor-pointer"
                }, {
                  default: _withCtx(() => _cache[80] || (_cache[80] = [
                    _createElementVNode("i", { class: "fa-solid fa-book mr-2 text-custom-medium-blue" }, null, -1),
                    _createTextVNode(" Read Documentation ")
                  ])),
                  _: 1,
                  __: [80]
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})